

























import { Component, Vue } from "vue-property-decorator";
import { storePasien } from "@/store/modules/pasien";
import ListPasienRalan from "@/store/modules/new/ListPasienRalan";

@Component
export default class PasienContextMenuButton extends Vue {
  pasienContextMenuItems = [
    {
      text: `Tandai Pasien Batuk > 2 Minggu`,
      onClick: () => ""
    }
  ];
}
